import * as d3 from 'd3';

export const CHART_COLORS = {
  axisText: 'var(--tds-grey-250)',
  grid: 'var(--tds-grey-500)',
  line: 'var(--tds-blue-300)',
  pointFill: 'var(--tds-grey-958)',
  pointStroke: 'var(--tds-white)',
} as const;

export const renderNotAvailable = (
  g: d3.Selection<SVGGElement, unknown, null, undefined>,
  chartWidth: number,
  chartHeight: number,
): void => {
  g.append('text')
    .attr('x', chartWidth / 2)
    .attr('y', chartHeight / 2 - 10)
    .attr('text-anchor', 'middle')
    .attr('dominant-baseline', 'middle')
    .attr('fill', CHART_COLORS.axisText)
    .style('font', 'var(--tds-detail-02)')
    .style('letter-spacing', 'var(--tds-detail-02-ls)')
    .style('font-size', '14px')
    .attr('font-weight', 400)
    .text('Not Available');
};

export const applyAxisStyleY = (axisGroup: d3.Selection<SVGGElement, unknown, null, undefined>): void => {
  axisGroup
    .selectAll('text')
    .attr('fill', CHART_COLORS.axisText)
    .attr('font-size', 11)
    .attr('dy', '0.32em')
    .attr('x', -6);
  axisGroup.select('.domain').remove();
  axisGroup.selectAll('line').remove();
};

export const applyAxisStyleX = (axisGroup: d3.Selection<SVGGElement, unknown, null, undefined>): void => {
  axisGroup.selectAll('text').attr('fill', CHART_COLORS.axisText).attr('font-size', 11).attr('dy', '0.9em');
  axisGroup.select('.domain').remove();
  axisGroup.selectAll('line').remove();
};
